export const apiServiceConstants = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    GETX: 'GETX',
    POSTX: 'POSTX',
    PUTX: 'PUTX',
    HEAD: 'HEAD'
};